import React from "react";
import "..//..//Style/Branch.css";

const CseSem1MDU = () => {
  return (
    <>
      <div style={{ backgroundColor: "#Dbe6ea" }}>
        <h1 class="mb-1">
          SEMESTER 1 <br />
          Select Your Subject
          <div class="spinner-grow text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </h1>
      </div>
      <div class="accordion" id="accordionExample">
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingOne">
            <button
              class="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              MATH -I (Calculus and Matrices)
            </button>
          </h2>
          <div
            id="collapseOne"
            class="accordion-collapse collapse show"
            aria-labelledby="headingOne"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body" id="sub">
              <a
                href="https://drive.google.com/file/d/1CHKLbzp4RMoIFchXqBi94Y2aFVvbebX7/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2009
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/drive/folders/1mFFqJgp00JM3Mg38DyUQszo4LPLqpeya?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2010
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/drive/folders/1uP-hc8AIt2_8rgVmAeOA-BLp_3Nm1M02?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2020
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/drive/folders/1hXtZ_OwO7YHqcfd-f0L5IPg6iBDOJdFZ?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2021
                </button>
              </a>
              <br />
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingTwo">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTwo"
              aria-expanded="false"
              aria-controls="collapseTwo"
            >
              PROGRAMMING FOR PROBLEM SOLVING
            </button>
          </h2>
          <div
            id="collapseTwo"
            class="accordion-collapse collapse"
            aria-labelledby="headingTwo"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body" id="sub">
              <a
                href="https://drive.google.com/drive/folders/114KolujqZ5C8JL_Uv9PyFG2JP4MjL747?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2020
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/drive/folders/1oiXgOnxZ6k5Jn1mikZavxzxeMpbYrQ27?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2021
                </button>
              </a>
              <br />
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingThree">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseThree"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              PHYSICS
            </button>
          </h2>
          <div
            id="collapseThree"
            class="accordion-collapse collapse"
            aria-labelledby="headingThree"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body" id="sub">
              <a
                href="https://drive.google.com/file/d/14_XBxrC0aAnfGIXgMokoOoQplmUMMX7q/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2009
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/drive/folders/1G8IL9gGZ9f2bN5N1nvqn_H7-NU5C3wcr?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2010
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1UEvEqvpiVcDuhWgAuLs3KoanatLDbHXT/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2020
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1-IMOIbTljR8aFLdabUiFm8Uw3qywwplV/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2021
                </button>
              </a>
              <br />
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingFour">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFour"
              aria-expanded="false"
              aria-controls="collapseFour"
            >
              CHEMISTRY
            </button>
          </h2>
          <div
            id="collapseFour"
            class="accordion-collapse collapse"
            aria-labelledby="headingFour"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body" id="sub">
              <a
                href="https://drive.google.com/drive/folders/1kgWRaFlqovzYwwiHMbXmY9gTCNLRzTz7?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" className="btn btn-primary">
                  2009
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/drive/folders/1dDlQKqXBz7bSD1JH2OAWyCouURfMvQwu?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button type="button" className="btn btn-primary">
                  2010
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/drive/folders/1Aj6KjRI8K3qAdDSFvq91ynleNuO_Q6Ks?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button type="button" className="btn btn-primary">
                  2020
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1ifSTVV-GHRp85xr7a8-IZn-iEPJzO4nc/view?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button type="button" className="btn btn-primary">
                  2021
                </button>
              </a>
              <br />
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingFive">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFive"
              aria-expanded="false"
              aria-controls="collapseFive"
            >
              ENGLISH
            </button>
          </h2>
          <div
            id="collapseFive"
            class="accordion-collapse collapse"
            aria-labelledby="headingFive"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body" id="sub">
              <a
                href="https://drive.google.com/file/d/1LC5Fk4H4yZ0AIvh05kDz738rZA97jtj6/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" className="btn btn-primary">
                  2020
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1ajLV0grFeg4XR3lVQubKLVTQ8PA2OIGe/view?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button type="button" className="btn btn-primary">
                  2021
                </button>
              </a>
              <br />
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingSix">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseSix"
              aria-expanded="false"
              aria-controls="collapseSix"
            >
              WORKSHOP TECHNOLOGY
            </button>
          </h2>
          <div
            id="collapseSix"
            class="accordion-collapse collapse"
            aria-labelledby="headingSix"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body" id="sub">
              <a
                href="https://drive.google.com/file/d/16HOPn2k9GUkQJBAZjYvSrLRO3x9TKZXV/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2021
                </button>
              </a>
              <br />
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingSeven">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseSeven"
              aria-expanded="false"
              aria-controls="collapseSeven"
            >
              BASIC ELECTRICAL ENGINEERING
            </button>
          </h2>
          <div
            id="collapseSeven"
            class="accordion-collapse collapse"
            aria-labelledby="headingSeven"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body" id="sub">
              <a
                href="https://drive.google.com/file/d/1Sqqq2QGmmLBGDvYH66PNr0IQJAjR7Axd/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2020
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1BbiXS_Ss2iqtgKsHrEVU0IUu2XG3XdOi/view?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className="btn btn-primary">2021</button>
              </a>
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header" id="headingEight">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseEight"
              aria-expanded="false"
              aria-controls="collapseEight"
            >
              BASICS OF ELECTRONICS
            </button>
          </h2>
          <div
            id="collapseEight"
            class="accordion-collapse collapse"
            aria-labelledby="headingEight"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body" id="sub">
              <a
                href="https://drive.google.com/file/d/16veioBLkR4XmW8yDyIcavvWXWTtsOa3G/view?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className="btn btn-primary">2020</button>
              </a>
              <a
                href="https://drive.google.com/file/d/1WG8LwmbV4R0BlcDfmgQtOhUQcbgaUCzc/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2021
                </button>
              </a>
              <br />
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header" id="headingNine">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseNine"
              aria-expanded="false"
              aria-controls="collapseNine"
            >
              BASIC OF MECHANICAL ENGINEERING
            </button>
          </h2>
          <div
            id="collapseNine"
            class="accordion-collapse collapse"
            aria-labelledby="headingNine"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body" id="sub">
              <a
                href="https://drive.google.com/file/d/1vOZsaubsdUwVHVV5Q7Qqk989PoJrn1sk/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2020
                </button>
              </a>
              <br />
              <a
                href="https://drive.google.com/file/d/1pwi3_GIu7DQXqjSyhRSqWaLkmFE-04-s/view?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className="btn btn-primary">2021</button>
              </a>
            </div>
          </div>
        </div>

        <div class="accordion-item">
          <h2 class="accordion-header" id="headingTen">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTen"
              aria-expanded="false"
              aria-controls="collapseTen"
            >
              ELECTRICAL TECHNOLOGY
            </button>
          </h2>
          <div
            id="collapseTen"
            class="accordion-collapse collapse"
            aria-labelledby="headingTen"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body" id="sub">
              <a
                href="https://drive.google.com/file/d/1MgwBy6kGB9ABoYkShkd7kANRsQEuJvPI/view?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className="btn btn-primary">2020</button>
              </a>
              <a
                href="https://drive.google.com/file/d/1AtAfaV8mR-FxUp7D0J5vNok9C-3kY9pY/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
              >
                <button type="button" class="btn btn-primary">
                  2021
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CseSem1MDU;
